<template>
  <div id="app">

    <div style="height: 100vh;" v-if="!Store.state.loaded">
        <div class="card-body p-0 spinner-center">
            <div class="p-4 code-to-copy">
                <div class="spinner-border" role="status"></div>
            </div>
        </div>
    </div>

    <router-view/>
  </div>
</template>

<style>
  @import "./assets/css/theme.min.css";
  @import "./assets/css/font-awesome.css";
</style>

<script>
import store from './events/Store'

export default {
  name: 'App',

  setup() {
    
    const Store = store

    return {
      Store
    }
  }
}
</script>
